import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SparkCoreModule } from '@core/core.module';
import { KycModule } from '@features/kyc/kyc.module';
import { LoadModule } from '@shared/components/load/load.module';
import { MenuModule } from '@shared/components/menu/menu.module';
import { SparkPlusModalModule } from '@shared/components/modal/modal.module';
import { SummaryCardModule } from '@shared/components/summary/summary-card/summary-card.module';
import { SummaryFieldModule } from '@shared/components/summary-field/summary-field.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/shared.module';

import { TaskContextMenuPipe } from './pipes/task-context-menu.pipe';
import { TaskDueDatePipe } from './pipes/task-due-date.pipe';
import { TaskFilterByPipe } from './pipes/task-filter-by.pipe';
import { TaskHasAssignedPriorityPipe } from './pipes/task-has-assigned-priority.pipe';
import { TaskNavigationUrlPipe } from './pipes/task-navigation-url.pipe';
import { TaskSortPipe } from './pipes/task-sort.pipe';
import { TaskTrackingStatusPipe } from './pipes/task-tracking-status.pipe';
import { TaskUrgencyPipe } from './pipes/task-urgency.pipe';
import { TaskRoutingModule } from './tasks-routing.module';
import { TaskConsolidatedComponent } from './views/consolidated/task-consolidated.component';
import { TaskEditComponent } from './views/edit/task-edit.component';
import { TaskListComponent } from './views/list/task-list.component';
import { TaskNewComponent } from './views/new/task-new.component';

@NgModule({
  declarations: [
    TaskContextMenuPipe,
    TaskTrackingStatusPipe,
    TaskDueDatePipe,
    TaskHasAssignedPriorityPipe,
    TaskUrgencyPipe,
    TaskFilterByPipe,
    TaskSortPipe,
    TaskNavigationUrlPipe,
    TaskConsolidatedComponent,
    TaskEditComponent,
    TaskNewComponent,
    TaskListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoadModule,
    TaskRoutingModule,
    ReactiveFormsModule,
    KycModule,
    SparkPlusModalModule,
    LoadModule,
    MenuModule,
    PipesModule,
    SummaryFieldModule,
    SummaryCardModule,
    KycModule,
    SparkCoreModule
  ],
  exports: [
    TaskContextMenuPipe,
    TaskTrackingStatusPipe,
    TaskDueDatePipe,
    TaskHasAssignedPriorityPipe,
    TaskUrgencyPipe,
    TaskEditComponent,
    TaskNewComponent,
    TaskListComponent
  ],
  providers: []
})
export class TasksModule {}
